import { ValeurChampAdditionnel } from "src/app/common/champs-additionnels/models/valeur-champ-additionnel";

export class FormationModel {
  id: number;
  nom: string;
  reference: string;
  dureeEnJours: number;
  dureeEnHeures: string;
  dureeEnseignementEnHeures: string;
  categorie: string;
  idValeurEtat: number;
  libelleEtat: string;
  active = true;
  idExterne: string;
  entites: Array<number>;
  idValeurDomaine: number;
  idTheme: number;
  idValeurModalite: number;
  description: string;
  effectifConseille: number;
  idPersonnelGestionnaireAdministratif: number;
  idPersonnelResponsablePedagogique: number;
  modalitesContact: string;
  competencesFormateurs: string;
  ressources: string;
  bpfActif: boolean;
  niveauBpf: number;
  idSpecialiteBpf: number;
  dureeEnDistanciel: number;
  dureeEnPresentiel: number;
  dpcActif: boolean;
  numeroDpc: string;
  nomDpc: string;
  orientationDpc: string;
  typeFormation: number[];
  champsPerso: ValeurChampAdditionnel[];
  aPublierSurSite: boolean;
  urlImage: string;
  estFormationComposee: boolean;
  EstFormationComposee: boolean;
  idEntitePrincipale: number;
  dateModification: Date
  dateCreation: Date;
  guidUtilisateurCreation: number;
  guidUtilisateurModification: number;
  isModifiable?: boolean;
}

export class FormationForFormationCompose{
  idFormationSimple: number;
  nom: string;
  sessions: SessionForSelection[];
}

export class SessionForSelection{
    idSession: number;
    libelleFormation: string;
    reference: string;
    dateDebut: Date;
    dateFin: Date;
    progression: number;
    selected: boolean = false;
}
